import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
} from 'react';
import { Page } from '../resources/constantes.json';
import styled from 'styled-components/macro';
import { useViewContext } from 'contexts/viewContext';
import GeneralPrint from './reports/General';
import Estadisticas from './reports/Estadisticas';

export default function Print(props) {
  const printEvent = usePrintEvent();
  useEffect(() => {
    const printPage = e => {
      if (e.ctrlKey && e.keyCode === 80) {
        e.preventDefault();
        printEvent();
      }
    };
    document.addEventListener('keydown', printPage);
    return () => document.removeEventListener('keydown', printPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { status } = usePrintState();
  return status !== 'hidden' ? (
    <div
      aria-hidden
      css={`
        @media screen {
          display: none;
        }
      `}
    >
      <Pages {...props} />
    </div>
  ) : null;
}

function Pages({ page, id, data, nomenclator, ini }) {
  const results = useMemo(() => ({ id, data }), [id, data]);
  const dispatch = usePrintDispatch();
  const state = usePrintState();
  const { view } = useViewContext();
  const { pathname } = window.location
  const pathArray = pathname.replace('/', '').split('/');

  useEffect(() => {
    if (state.status === 'pending') {
      dispatch({ type: 'painted' });
    }
  }, [dispatch, state.status]);
  if (['visible', 'done'].includes(state.status)) {
    return (view === 'estadisticas' || pathArray[0] === 'estadisticas') ? <Estadisticas /> : <GeneralPrint data={results} nomenclator={nomenclator} ini={ini} />
  } else {
    return <></>;
  }
}

function noop() { }
const initialState = { status: 'hidden' };
const PrintStateContext = createContext(initialState);
const PrintDispatchContext = createContext(noop);

function reducer(_state, event) {
  switch (event.type) {
    case 'hide':
      return { status: 'hidden' };
    case 'print':
      return { status: 'pending' };
    case 'painted':
      return { status: 'visible' };
    case 'done':
      return { status: 'done' };
    default:
      throw new Error();
  }
}
export function PrintProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    if (state.status === 'visible') {
      document.body.style.cursor = 'default';
      window.print();
      dispatch({ type: 'done' });
    }
  }, [state.status]);
  return (
    <PrintStateContext.Provider value={state}>
      <PrintDispatchContext.Provider value={dispatch}>
        {children}
      </PrintDispatchContext.Provider>
    </PrintStateContext.Provider>
  );
}

export function usePrintState() {
  return useContext(PrintStateContext);
}

export function usePrintDispatch() {
  return useContext(PrintDispatchContext);
}

export function usePrintEvent() {
  const dispatch = useContext(PrintDispatchContext);
  return useCallback(() => {
    document.body.style.cursor = 'wait';
    dispatch({ type: 'print' });
  }, [dispatch]);
}

// type status = "hidden"| "visible" | "pending" | "done";
